module.exports = __webpack_public_path__ + "static/media/iconmonstr-youtube-music-5.29b826fc.svg";